import {Center} from '@mantine/core';
import {css, StyleSheet} from 'aphrodite';
import React, {useMemo} from 'react';

import {assertAndContinue} from 'Asserts';
import OptionCellDropdown from 'notebook/plain-tables/selectors/OptionCellDropdown';
import {BooleanOptions, getBooleanFromString, getStringFromBoolean} from 'schemas/tags/BooleanUtil';

interface BooleanValueCellEditorProps {
  value?: boolean | null;
  onUpdate: (tag: {value: string; booleanValue: boolean | null}) => void;
  isSelected?: boolean;
  locked?: boolean;
}

export default function BooleanValueCellEditor(props: BooleanValueCellEditorProps): JSX.Element {
  const staticDisplay = useMemo(
    () => <div className={css(styles.cellContents)}>{getStringFromBoolean(props.value)}</div>,
    [props.value]
  );

  if (props.locked || props.isSelected === false) {
    return staticDisplay;
  }

  return (
    <Center className="u-position-relative u-height-full">
      <OptionCellDropdown
        locked={props.locked ?? false}
        isSelected={props.isSelected ?? true}
        options={Object.values(BooleanOptions)}
        onUpdate={(newValue) => {
          const newBoolean = getBooleanFromString(newValue);
          if (assertAndContinue(newBoolean != null, `Invalid value selected: ${newValue}`)) {
            props.onUpdate({
              value: newValue,
              booleanValue: newBoolean,
            });
          }
        }}
        staticDisplay={staticDisplay}
        fullWidth={true}
        lightHoverBackground={true}
      />
    </Center>
  );
}

const styles = StyleSheet.create({
  cellContents: {
    textAlign: 'center',
  },
});
